import "utils/suppressResizeObserverError";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import client from "./client";
import App from "App";
import { AuthContextProvider } from "context";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

ReactDOM.render(
  <BrowserRouter>
    <ApolloProvider client={client}>
      <AuthContextProvider>
        <MaterialUIControllerProvider>
          <App />
        </MaterialUIControllerProvider>
      </AuthContextProvider>
    </ApolloProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
